export const PreferencesPath = 'preferences';
export const PortfolioPath = 'portfoliodetail';
export const InvestmentPath = 'investments';

// investor
export const InvestorAllocatedLoansPath = 'lender/:lenderId/allocated-loans';

// investor commons
export const RecentlyFilledLoansPath = 'recently-filled-loans';
